'use client';

import { GridCard } from '@/shared/components/GridCard';
import { ProjectTypeCard } from '@/features/projects/components/ProjectTypeCard';
import { ProjectsTable } from '@/features/projects/components/ProjectsTable';
import { ShareProjectModal } from '@/features/projects/components/ShareProjectModal';
import { ClipboardList, FolderPlus } from 'lucide-react';
import { useHomePage } from '@/features/projects/hooks/useHomePage';
import { Loader } from '@/shared/components/Loader';
import { useNamespacedTranslate } from '@/shared/lib/locales';

export default function HomePage() {
  const t = useNamespacedTranslate('homePage');

  const {
    projects,
    isLoading,
    shareProject,
    handleCreateProject,
    handleDeleteProject,
    handleManageCollaborators,
    handleCloseShareProject,
    handleShareSaved,
    pageNumber,
    setPageNumber,
    pageSize,
    setPageSize,
    total,
    sortBy,
    sortOrder,
    onSortChange,
  } = useHomePage();

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <GridCard title={t('quickActionsTitle')}>
        <ProjectTypeCard
          title={t('newProjectTitle')}
          description={t('newProjectDescription')}
          iconBg="bg-green-700"
          icon={FolderPlus}
          onClick={handleCreateProject}
        />
        <ProjectTypeCard
          title={t('questionnairesTitle')}
          description={t('questionnairesDescription')}
          iconBg="bg-blue-700"
          icon={ClipboardList}
          href="/questionnaires"
        />
      </GridCard>
      <GridCard title={t('projectsTitle')}>
        {isLoading && projects.length === 0 ? (
          <div className="w-full">
            <Loader text={t('loadingProjects')} />
          </div>
        ) : (
          <div className={isLoading ? 'opacity-60 pointer-events-none transition-opacity' : 'transition-opacity'}>
            <ProjectsTable
              projects={projects}
              onDelete={handleDeleteProject}
              onManageCollaborators={handleManageCollaborators}
              page={pageNumber}
              pageSize={pageSize}
              total={total}
              onPageChange={setPageNumber}
              onPageSizeChange={setPageSize}
              sortBy={sortBy}
              sortOrder={sortOrder}
              onSortChange={onSortChange}
            />
          </div>
        )}
      </GridCard>

      {shareProject && (
        <ShareProjectModal
          project={shareProject}
          onClose={handleCloseShareProject}
          onSaved={handleShareSaved}
        />
      )}
    </div>
  );
}
